import * as T_T from 'cryface';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

export namespace HousePriceEvaluateValidator {
    export function validator(data: any) {
        const errorStack: string[] = [];
        if (!T_T.simpleDetect(data)) {
            errorStack.push('Address Is Empty');
        }
        if (errorStack.length > 0) {
            return errorStack[0];
        } else {
            return null;
        }
    }

    export function isDigit(val: string) {
        return T_T.isMatchRegex(val, /^\d+$/);
    }

    export function isEmail(val: string) {
        const emailText = val;
        const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if (pattern.test(emailText)) {
            return true;
        } else {
            return false;
        }
    }
}
